const en = {
    "Bem-vindo à Assembleia Nacional":"Welcome to the National Assembly",
    "Continuar":"Continue",
    "Escolha seu Idioma":"Choose your language",
    "O Palácio da Assembleia Nacional":"The Palace of the National Assembly",
    "História da Assembleia":"History of the Assembly",
    "Galeria":"Gallery",
    "Quiz":"Quiz",
    "Símbolos":"Symbols",
    "Visita Virtual":"Virtual visit",
    "Constituição":"Constitution",
    "Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República":"Test your knowledge about the Assembly, Parliament, Constitution and the Republic",
    "Modo":"Mode",
    "Jogar":"Play",
    "15 segundos":"15 seconds",
    "Clássico":"Classic",
    "sem registros":"no records",
    "sair":"back",
    "pontos":"score",
    "Tema":"Topic",
    "Parabens acertaste todas as nossas questões":"Congratulations, you got all our questions right",
    "Tempo esgotado":"Time is over",
    "Resposta errada":"Incorect answer",
    "Fim do Quiz":"Game over",
    "Total de Pontos":"Total Score",
    "Novo Record":"New Record",
    "seu nome":"your name",
    "salvar":"save",
    "responder novamente":"answer again",
    "lugar":"place",
    "Por favor degite seu nome":"Please enter your name",
    "Atuais":"Actual",
    "Antigos":"Older",
    "Autor":"Author",
    "Compositor":"Composer",
    "Este browser não suporta audio":"This browser does not support audio",
    "letra":"lyrics",
    "Título":"Title",
    "descrição":"description",
    "Bandeira":"Flag",
    "Hino":"Anthem",
    "Armas":"Coat of Arms",
    "Bandeira (1975-1992)":"Flag (1975-1992)",
    "Hino (1975-1992)":"Anthem (1975-1992)",
    "Armas (1975-1992)":"Coat of Arms (1975-1992)",
    "Constituição da República":"Constitution of the Republic",
    "fotos":"photos",
    "Carregando":"Loading",
    "procurar por artigos":"search for articles",
    "procurar":"search",
    "Nenhum resultado encontrado":"No results found",
    "voltar":"back",
    "Por favor degite um valor válido":"Please enter a valid value"
}

export default en;